import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { CircleGrid } from "react-awesome-shapes/dist/shapes/circlegrid";
import { Donut } from "react-awesome-shapes/dist/shapes/donut";

const ContactForm = () => {
  return (
    <main className="overflow-hidden">
      {/* Contact section */}
      <section
        className="relative bg-white mb-32"
        aria-labelledby="contact-heading">
        <CircleGrid
          position="absolute"
          top="0rem"
          color="#863d90"
          size="80px"
          className="hidden lg:inline"
          zIndex={0}
        />
        <CircleGrid
          position="absolute"
          right="0"
          top="5rem"
          color="#863d90"
          size="80px"
          className="hidden lg:inline"
          zIndex={0}
        />
        <Donut
          color="#863d90"
          top="1rem"
          left="1rem"
          size="4rem"
          className="hidden lg:inline lg:animate-shape"
          width={["0.5rem", "1rem", "1rem", "1rem"]}
          zIndex={0}
        />
        <Donut
          color="#863d90"
          top="6rem"
          right="1rem"
          size="4rem"
          className="hidden lg:inline lg:animate-shape"
          width={["0.5rem", "1rem", "1rem", "1rem"]}
          zIndex={0}
        />
        {/* SMALL shapes decoration */}
        <CircleGrid
          position="absolute"
          right="5rem"
          top="2rem"
          color="#863d90"
          size="50px"
          className="hidden lg:inline"
          zIndex={0}
        />
        <CircleGrid
          position="absolute"
          right="2rem"
          top="12rem"
          color="#863d90"
          size="50px"
          className="hidden lg:inline"
          zIndex={0}
        />
        <CircleGrid
          position="absolute"
          left="5rem"
          top="8rem"
          color="#863d90"
          size="50px"
          className="hidden lg:inline"
          zIndex={0}
        />
        <CircleGrid
          position="absolute"
          left="2rem"
          top="13rem"
          color="#863d90"
          size="50px"
          className="hidden lg:inline"
          zIndex={0}
        />
        <div className="max-w-7xl lg:max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative bg-white shadow-xl rounded-xl">
            <div className="grid">
              {/* Contact information */}
              <div className="relative overflow-hidden py-10 px-6 bg-purple text-white sm:px-10 xl:p-12 rounded-xl ring-4 ring-offset-2 ring-purple mt-2">
                <h3 className="text-lg font-medium text-white">
                  Contact information
                </h3>
                <p className="mt-6 text-base text-teal-50 max-w-3xl">
                  Have a question in mind? There are many ways to reach us.
                </p>
                <dl className="mt-8 space-y-6">
                  <dt>
                    <span className="sr-only">Phone number</span>
                  </dt>
                  <dd className="flex text-base text-white">
                    <PhoneIcon
                      className="flex-shrink-0 w-6 h-6 text-white stroke-white stroke-2"
                      aria-hidden="true"
                    />
                    <a href="tel:0456 206 990">
                      <span className="ml-3 hover:text-yellow">
                        0456 206 990
                      </span>
                    </a>
                  </dd>
                  <dt>
                    <span className="sr-only">Email</span>
                  </dt>
                  <dd className="flex text-base text-white">
                    <EnvelopeIcon
                      className="flex-shrink-0 w-6 h-6 text-white stroke-white stroke-2"
                      aria-hidden="true"
                    />
                    <a href="mailto:tutorwo.tutoring@gmail.com">
                      <span className="ml-3 hover:text-yellow">
                        tutorwo.tutoring@gmail.com
                      </span>
                    </a>
                  </dd>
                </dl>
                <ul className="mt-8 flex space-x-12 ">
                  <li>
                    <a
                      className="text-white hover:text-yellow"
                      href="https://www.instagram.com/tutorwo_/"
                      target="_blank">
                      <span className="sr-only">Instagram</span>
                      <InstagramIcon sx={{ fontSize: "1.8rem" }} />
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-white hover:text-yellow"
                      href="https://www.facebook.com/TutorWo"
                      target="_blank">
                      <span className="sr-only">Facebook</span>
                      <FacebookIcon sx={{ fontSize: "1.8rem" }} />
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-white hover:text-yellow"
                      href="https://www.linkedin.com/company/tutorwo/"
                      target="_blank">
                      <span className="sr-only">LinkedIn</span>
                      <LinkedInIcon sx={{ fontSize: "1.8rem" }} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactForm;
